import { SpiralMarkIcon } from "@/components/icons/SpiralMarkIcon";
import { community, site } from "@/content/site";
import { asset } from "@/lib/assets";

export function Community() {
  return (
    <section id="info" className="bg-brand-sky lg:h-[1080px] overflow-hidden scroll-mt-20 lg:scroll-mt-28">
      <div className="container mx-auto py-12 lg:py-40 px-5 h-full">
        <div className="relative bg-brand-navy rounded-2xl h-full pb-40 min-h-[43rem] sm:min-h-0 z-10">
          <div className="px-10 py-10 lg:py-20 w-full sm:w-[85%] md:w-4/5 lg:w-8/12 xl:w-7/12 2xl:w-6/12 lg:float-right lg:mr-10 xl:mr-6 2xl:mr-32 lg:-mt-2 xl:mt-8">
            {/* `sm:leading-none` restores the line-height that the responsive
                font-size utilities used to carry in Tailwind v3. */}
            <h2 className="uppercase text-[2.6rem] leading-[3.2rem] sm:leading-none sm:text-5xl lg:text-6xl xl:text-7xl text-white font-extrabold">
              {community.headline} <br />
              <span className="text-brand-sky italic">{community.headlineHighlight}</span>
            </h2>

            {/* Capped measure keeps the line length readable no matter how wide
                the card gets. */}
            <p className="mt-6 max-w-[44ch] text-lg/relaxed font-medium text-white/75 lg:mt-8 lg:text-xl xl:text-2xl">
              Ganha <strong className="font-bold text-brand-sky">Free Spins</strong> na roda da sorte enquanto jogas e fica a par de tudo no Discord.
            </p>

            <div className="mt-8 flex items-baseline gap-4 lg:mt-10">
              <span className="text-5xl font-extrabold leading-none text-brand-sky xl:text-6xl">
                {community.memberCount.toLocaleString("pt-PT")}
                <span aria-hidden>+</span>
              </span>
              <span className="font-roboto text-xs uppercase tracking-[0.2em] text-white/50 sm:text-sm">membros</span>
            </div>

            <a
              href={site.discordUrl}
              target="_blank"
              rel="noreferrer"
              className="mt-8 inline-flex w-fit items-center justify-center rounded-full bg-brand-sky px-10 py-4 font-roboto text-lg font-bold uppercase tracking-wide text-brand-navy transition-colors duration-200 hover:bg-white focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-sky lg:mt-10 xl:text-xl"
            >
              Entrar no Discord
            </a>
          </div>

          <div className="absolute -bottom-8 left-8 sm:-bottom-16 sm:left-32 lg:-bottom-20 lg:-left-20 xl:-bottom-28 xl:-left-32 2xl:top-20 2xl:-left-32 w-full -scale-x-100 lg:scale-x-100 -z-10">
            <img
              className="w-[95%] sm:w-[95%] md:w-[85%] lg:w-4/6"
              src={asset("images/webp/playandwin.webp")}
              alt=""
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="absolute bottom-0 right-0 hidden lg:block">
            <SpiralMarkIcon className="w-[25rem]" />
          </div>
        </div>
      </div>
    </section>
  );
}
